import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserType } from '@rci/self-serve-fido/state/app.state.model';
import { has } from 'lodash';
import { Account } from './account';
import { UserInformation } from './user-information';

export const UserInformationFeatureKey = 'userInformation';

export const userInformationState = createFeatureSelector<UserInformation>(UserInformationFeatureKey);

export const getAccountsList = createSelector(userInformationState, (userInformation: UserInformation) =>
  !!has(userInformation, 'accounts') ? userInformation.accounts : [],
);

export const getSelectedAccountNumber = createSelector(
  userInformationState,
  (userInformation: UserInformation) => userInformation.selectedAccountNumber,
);

export const getAccount = () =>
  createSelector(getAccountsList, (accounts: Account[], props) => {
    return accounts.find((item: Account) => {
      return item.accountNumber === props.accountNumber;
    });
  });

export const getSelectedAccount = createSelector(
  getAccountsList,
  getSelectedAccountNumber,
  (accounts, accountNumber) => {
    return getAccount().projector(accounts, { accountNumber });
  },
);

export const getFirstAccount = createSelector(getAccountsList, (accounts: Account[]) => accounts[0]);

export const getAccountSelectorData = createSelector(
  getAccountsList,
  getSelectedAccountNumber,
  (accounts: Account[], accountNumber) => {
    return {
      accounts,
      selectedAccount: accountNumber,
    };
  },
);

export const isAgent = createSelector(
  userInformationState,
  (userInformation: UserInformation) => !!userInformation.cfaInfo,
);

export const getUserType = createSelector(isAgent, _isAgent => (_isAgent ? UserType.agent : UserType.consumer));
